<template>
  <CourseListWtxh v-if="siteId == 116" />
  <CourseListDefault v-else />
</template>

<script>
import CourseListDefault from "./courseListDefault.vue";
import CourseListWtxh from "./courseListWtxh.vue";

export default {
  name: "CourseListContainer",
  components: {
    CourseListDefault,
    CourseListWtxh,
  },
  data() {
    return {
      siteId: null,
    };
  },
  created() {
    let info = localStorage.getItem("siteInfo");
    if (info) {
      this.siteId = JSON.parse(info).id;
    }
  },
};
</script>
